import type { PurchaseVerdict } from "./Analysis";
import type { Tone } from "./Tone";

// Цвет оценки покупки: как у находок; «по ситуации», редкий выбор и «нет эталона» — без оценки.
export const PURCHASE_VERDICT_TONES: Record<PurchaseVerdict, Tone> = {
  on_time: "good",
  late: "warn",
  very_late: "bad",
  situational: "neutral",
  rare: "neutral",
  no_baseline: "neutral",
};
